import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { H1 } from '../../components/Shared/Headings';
import { Link } from 'react-router-dom';

import * as accountActions from '../../redux/actions/accountActions';
import * as eulaActions from '../../redux/actions/eulaActions';
import * as referenceDataActions from '../../redux/actions/referenceDataActions';

import styles from './RegisterAccountPage.module.scss';

import { Section, SectionInner } from '../../components/Shared/Section';
import { InputItem } from '../../components/Shared/Forms';
import { Button } from '../../components/Shared/Buttons';
import { AlertBox } from '../../components/Shared/Alerts';
import { ReactComponent as Logo } from '../../shared/icons/assets_login-logo.svg';

import Modal from '../../components/Shared/Modal/Modal';

class RegisterAccountPage extends Component {
  constructor(props) {
    super();

    this.state = {
      email: '',
      password: '',
      passwordRepeat: '',
      eulaCountry: '',
      termsOfServiceAccepted: false,
      showModal: false,
      firstPage: true,
    };
    this.intl = props.intl;
    this.emailChanged = this.emailChanged.bind(this);
    this.passwordChanged = this.passwordChanged.bind(this);
    this.passwordRepeatChanged = this.passwordRepeatChanged.bind(this);
    this.countryChanged = this.countryChanged.bind(this);
    this.registerAccount = this.registerAccount.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.termsOfServiceChanged = this.termsOfServiceChanged.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.goog_report_conversion = this.goog_report_conversion.bind(this);
    this.start = this.start.bind(this);

    this.steps = [
      {
        icon: 'profile',
        text: this.intl.formatMessage({
          id: 'registerAccount.step1',
          defaultMessage: 'Register new account',
        }),
      },
      {
        icon: 'email',
        text: this.intl.formatMessage({
          id: 'registerAccount.step2',
          defaultMessage: 'Confirm your email',
        }),
      },
      {
        icon: 'clinic',
        text: this.intl.formatMessage({
          id: 'registerAccount.step3',
          defaultMessage: 'Create your profile and clinic',
        }),
      },
      {
        icon: 'beacon',
        text: this.intl.formatMessage({
          id: 'registerAccount.step4',
          defaultMessage: 'Register your instrument',
        }),
      },
      {
        icon: 'smartpeg',
        text:
          this.intl.formatMessage({
            id: 'registerAccount.step5',
            defaultMessage: 'Collect your FREE SmartPegs!',
          }) + '*',
      },
    ];
  }

  componentDidMount() {
    this.props.actions.getCountries();
    const script = document.createElement('script');
    script.src = '//www.googleadservices.com/pagead/conversion_async.js';
    script.async = true;
    document.body.appendChild(script);
  }

  toggleModal(event) {
    event.preventDefault();
    this.setState({
      showModal: !this.state.showModal,
    });
  }

  emailChanged(evt) {
    this.setState({
      email: evt.target.value.toLowerCase().trim(),
    });
  }

  passwordChanged(evt) {
    this.setState({
      password: evt.target.value,
    });
  }

  passwordRepeatChanged(evt) {
    this.setState({
      passwordRepeat: evt.target.value,
    });
  }

  countryChanged(option) {
    this.setState({
      eulaCountry: option.value,
    });
    this.props.actions.getEula(option.value);
  }

  termsOfServiceChanged() {
    this.setState({
      termsOfServiceAccepted: !this.state.termsOfServiceAccepted,
    });
  }

  registerAccount() {
    const errorMessages = [];

    if (!this.state.termsOfServiceAccepted && this.props.eula.id) {
      errorMessages.push({
        text: this.intl.formatMessage({
          id: 'registerAccount.ReqestEula',
          defaultMessage: 'Please read and accept terms of service',
        }),
      });
    }

    if (errorMessages.length > 0) {
      this.setState({
        error: {
          messages: errorMessages,
        },
      });

      return;
    }

    this.setState({
      error: undefined,
    });

    const accountData = Object.assign({}, this.state);
    accountData.eulaId = this.props.eula.id;

    this.props.actions.registerAccount(accountData);
  }

  handleKeyPress(event) {
    if (event.key === 'Enter') {
      this.registerAccount();
    }
  }

  goog_report_conversion(url) {
    window.google_conversion_id = 975253165;
    window.google_conversion_label = 'BkF0COH-lnQQrd2E0QM';
    window.google_remarketing_only = false;
    window.google_conversion_format = '3';
    var opt = {};
    opt.onload_callback = function () {
      if (typeof url !== 'undefined') {
        window.location.pathname = url;
      }
    };
    var conv_handler = window['google_trackConversion'];
    if (typeof conv_handler === 'function') {
      conv_handler(opt);
    }
  }

  disableNext() {
    return (
      !this.state.email ||
      !this.state.password ||
      !this.state.passwordRepeat ||
      !this.state.eulaCountry ||
      !this.state.termsOfServiceAccepted
    );
  }

  renderFistPage() {
    const steps = this.steps.map((step, index) => {
      return (
        <div key={index}>
          {index > 0 ? <div className={styles.divider}></div> : null}
          <div className={styles.step}>
            <div className={styles.stepIcon}>
              <i>{step.icon}</i>
            </div>
            {step.text}
          </div>
        </div>
      );
    });
    return (
      <div>
        <H1>
          <FormattedMessage id="registerAccount.GetStarted" defaultMessage="Get started in 5 min" />
        </H1>
        <p className={styles.p}>
          <FormattedMessage
            id="registerAccount.WeWillGuide"
            defaultMessage="We will guide you through the following registration steps!"
          />
        </p>
        <div>{steps}</div>
        <span>
          *
          <FormattedMessage
            id="registerAccount.FreeSmartPegDisclaimer"
            defaultMessage="not valid in every country"
          />
        </span>
        <Button
          primary
          big
          full
          value={this.intl.formatMessage({ id: 'general.start', defaultMessage: "Let's start" })}
          rightIcon="forward"
          onClick={this.start}
        />
        <Link to="/">
          <Button
            rightIcon="back"
            className={styles.cancelButton}
            big
            full
            value={this.intl.formatMessage({ id: 'general.cancel', defaultMessage: 'Cancel' })}
          />
        </Link>
      </div>
    );
  }

  renderTerms() {
    if (this.state.eulaCountry) {
      return (
        <div>
          <p className={styles.small}>
            {this.intl.formatMessage({
              id: 'registerAccount.RegisterTerms',
              defaultMessage: 'Register Terms',
            })}
            .
          </p>
          <div className={styles.inputRow}>
            <InputItem
              label={this.intl.formatMessage({
                id: 'registerAccount.ConfirmEula',
                defaultMessage: 'I have read and accept the terms and conditions',
              })}
              type="checkbox"
              onChange={this.termsOfServiceChanged}
              onKeyPress={this.handleKeyPress}
              noBorder
            />
            <button className={styles.termsLink} onClick={this.toggleModal}>
              <FormattedMessage
                id="registerAccount.TermsAndConditions"
                defaultMessage="Terms and conditions"
              />
            </button>
          </div>
        </div>
      );
    }
  }

  start() {
    this.setState({ firstPage: false });
  }

  render() {
    let content;

    if (this.props.accountRegistration.complete) {
      this.goog_report_conversion();
      content = (
        <div>
          <H1>
            <FormattedMessage
              id="registerAccount.ConfirmAccount"
              defaultMessage="Please confirm your email"
            />
          </H1>
          <p>
            <FormattedMessage
              id="registerAccount.SentEmail"
              defaultMessage="We have sent an email to: "
            />
            <b>{this.state.email}</b>
          </p>
          <p>
            <FormattedMessage
              id="registerAccount.CheckEmail"
              defaultMessage="Please follow the link in the email to confirm your account. The link is valid for 12h."
            />
          </p>
          <p>
            <FormattedMessage
              id="registerAccount.EmailInformation"
              defaultMessage="If you haven’t received the email within a few minutes, please check your spam inbox or consult with your IT department"
            />
          </p>
          <p>
            <FormattedMessage
              id="registerAccount.Contact"
              defaultMessage="If you have any issues or questions, please contact Osstell Support at: "
            />
            <a href="mailto:support@osstell.com">support@osstell.com</a>
          </p>
          <br></br>
          <Link to="/">
            <Button
              primary
              big
              full
              value={
                <FormattedMessage id="profile.backToMainPage" defaultMessage="Back to start page" />
              }
            />
          </Link>
        </div>
      );
    } else if (this.state.firstPage) {
      content = this.renderFistPage();
    } else {
      const error = this.state.error || this.props.accountRegistration.error;
      const countries = this.props.countries.map((country) => {
        return { label: country.value, value: country.key };
      });

      content = (
        <div>
          <H1>
            <FormattedMessage
              id="registerAccount.RegisterNewAccount"
              defaultMessage="Register new account"
            />
          </H1>
          <p className={styles.p}>
            <FormattedMessage
              id="registerAccount.EnterEmailAndPassword"
              defaultMessage="Please enter an email and password for your new account"
            />
          </p>
          {error ? (
            <AlertBox
              headerText={this.intl.formatMessage({
                id: 'general.generalError',
                defaultMessage: 'Oops, there was an error',
              })}
              messages={error.messages.map((m) => m.text)}
            />
          ) : null}
          <div className={styles.inputGroup}>
            <InputItem
              label={this.intl.formatMessage({ id: 'general.email', defaultMessage: 'Email' })}
              type="text"
              onChange={this.emailChanged}
              onKeyPress={this.handleKeyPress}
              value={this.state.email}
            />
            <div className={styles.inputRow}>
              <InputItem
                label={this.intl.formatMessage({
                  id: 'general.password',
                  defaultMessage: 'Password',
                })}
                type="password"
                onChange={this.passwordChanged}
                onKeyPress={this.handleKeyPress}
                value={this.state.password}
              />
              <InputItem
                label={this.intl.formatMessage({
                  id: 'registerAccount.repeatPassword',
                  defaultMessage: 'Repeat Password',
                })}
                type="password"
                onChange={this.passwordRepeatChanged}
                onKeyPress={this.handleKeyPress}
                value={this.state.passwordRepeat}
              />
            </div>
            <p className={styles.comment}>
              <FormattedMessage
                id="registerAccount.Comment"
                defaultMessage="The password must be at least 6 characters long and contain: uppercase, lowercase, number and special sign."
              />
            </p>
            <p className={styles.p}>
              <FormattedMessage
                id="registerAccount.TermsAndConditions"
                defaultMessage="Terms and conditions"
              />
            </p>
            <InputItem
              label={this.intl.formatMessage({
                id: 'registerAccount.SelectCountry',
                defaultMessage: 'Please select country for applicable terms and condition',
              })}
              type="search-select"
              options={countries}
              onChange={this.countryChanged}
              value={this.state.eulaCountry}
            />
            {this.renderTerms()}
          </div>
          <Button
            primary
            big
            full
            value={this.intl.formatMessage({ id: 'general.next', defaultMessage: 'Next' })}
            rightIcon="forward"
            onClick={this.registerAccount}
            disabled={this.props.accountRegistration.busy || this.disableNext()}
            loading={this.props.accountRegistration.busy}
          />
          <Link to="/">
            <Button
              rightIcon="back"
              className={styles.cancelButton}
              big
              full
              value={this.intl.formatMessage({ id: 'general.cancel', defaultMessage: 'Cancel' })}
            />
          </Link>
        </div>
      );
    }
    return (
      <div className={styles.registrationPage}>
        {/* <KeyHandler keyEventName={KEYPRESS} keyValue="Enter" onKeyHandle={this.registerAccount} /> */}
        <div className={styles.fullHeight}>
          <Section>
            <SectionInner>
              <div className={styles.registrationPanelWrapper}>
                <div className={styles.registrationPanel}>
                  <div className={styles.logo}>
                    <Logo />
                  </div>
                  {content}
                </div>
              </div>
            </SectionInner>
          </Section>
        </div>
        <Modal
          header={this.intl.formatMessage({
            id: 'registerAccount.TermsAndConditions',
            defaultMessage: 'Terms and conditions',
          })}
          show={this.state.showModal}
          onDismiss={this.toggleModal}
          dismissOnClick
        >
          {this.props.getEula.complete ? (
            this.props.eula.data ? (
              <div dangerouslySetInnerHTML={this.props.eula.data} />
            ) : null
          ) : null}
        </Modal>
      </div>
    );
  }
}

function mapState(state) {
  return {
    countries: state.referenceData.countries,
    locale: state.translation.locale,
    accountRegistration: state.account.accountRegistration,
    getEula: state.eula.getEula,
    eula: state.eula.eula,
  };
}

function mapDispatch(dispatch) {
  return {
    actions: bindActionCreators(
      { ...accountActions, ...eulaActions, ...referenceDataActions },
      dispatch
    ),
  };
}

export default connect(mapState, mapDispatch)(injectIntl(RegisterAccountPage));
